module.exports = __webpack_public_path__ + "img/icon_menu_user_main.5c93178a.svg";